import React from 'react';

import { List } from '@gogame/components';

const Menu = ({ children }) => {
  return (
    <List disablePadding component={'div'}>
      {children}
    </List>
  );
};

export default Menu;
